import type { DemoDashboard } from '../../../types'
import { CustomerPnlDashboard } from './CustomerPnlDashboard'
import { LaborForecastDashboard } from './LaborForecastDashboard'
import { OpsPulseDashboard } from './OpsPulseDashboard'

/**
 * Cascade 3PL demo dashboards registered with the demo set. The order here
 * is the order they appear on the Dashboards list page when the set is
 * active.
 */
export const cascade3plDashboards: DemoDashboard[] = [
  {
    id: 'cascade-ops-pulse',
    title: 'Operations Pulse',
    description:
      "Real-time + this-week network operations. Today's volume, on-time performance, exceptions, agent activity, carrier perf.",
    lastUpdatedLabel: 'live · refreshes every minute',
    emoji: '⚡',
    Component: OpsPulseDashboard,
  },
  {
    id: 'cascade-customer-pnl',
    title: 'Customer P&L Forecast',
    description:
      'Forward + historical per-customer profitability across 68 active brands. Northwind margin trajectory + mix-shift drivers.',
    lastUpdatedLabel: 'updated 4:00 AM today',
    emoji: '💰',
    Component: CustomerPnlDashboard,
  },
  {
    id: 'cascade-labor-forecast',
    title: 'Labor Forecast & Capacity',
    description:
      '14-day forward labor across 4 fulfillment centers. Network heatmap + per-facility breakdown + Indy daily stack + Traba history.',
    lastUpdatedLabel: 'updated 4:30 AM today',
    emoji: '👥',
    Component: LaborForecastDashboard,
  },
]
